import { createSlice } from "@reduxjs/toolkit";

export interface IModuleState {
  openDialogModule: boolean;
  modules: IModule[];
  objModule: IModule;
  openEdit:boolean;
  valueModule:string;
  valueEdit:string;
  
}

export interface IModule {
  idModule: string;
  libelleModule: string;
}



export const moduleSlice: any = createSlice({
  name: "module",
  initialState: {
    openDialogModule: false,
    modules: [],
    objModule: {},
    openEdit:false,
    valueModule:"",
    valueEdit:"",
 
  },
  reducers: {

    setOpenDialogModule: (state, action) => {
      state.openDialogModule = action.payload;
    },
    setValueEdit: (state, action) => {
      state.valueEdit = action.payload;
    },

    setOpenEdit: (state, action) => {
      state.openEdit = action.payload;
    },

    addModules: (state, action) => {
      const newModule: any = [...state.modules, action.payload]
      state.modules = newModule;
    },

    setModules: (state, action) => {
      state.modules = action.payload;
    },

    setObjModule: (state, action) => {
      state.objModule = action.payload;
    },

    deleteModule: (state, action) => {
      state.modules = state.modules.filter((m: IModule) => m.idModule !== action.payload);
    },

    editModule: (state, action) => {
      const newModule: any = state.modules.map((m: IModule) => (m.idModule === action.payload.idModule ? action.payload : m))
      state.modules = newModule;
    },

  }
});

export const { setOpenDialogModule,
  addModules,
  setModules,
  setObjModule,
  deleteModule,
  editModule,
  setOpenEdit,
  setValueEdit
} = moduleSlice.actions;


export default moduleSlice.reducer;
